import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import { Box, Flex } from "../components/Flex"
import SideBar, {
  Title,
  Content,
  HelpCenterIndex
} from "./_help-center.elements"
import { HTMLContent } from "../components/Content"
import SearchBar from "../components/SearchBar"
import styled from "styled-components"
import slugify from "slugify"
import { setCurrentLang } from "../i18n"
import { useTranslation } from "react-i18next"
import { toHtml } from "../utils"

const NewHtmlComponent = styled(HTMLContent)`
  padding-bottom: 3rem;
  ol {
    li {
      line-height: 2.125rem;
      font-size: 18px;
      font-weight: 500;
    }
  }
`
export const HelpCenterPageTemplate = ({
  frontmatter,
  path,
  isIndex,
  groups
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Flex justifyContent="center">
        <Title>
          <h2>{t("questions")}</h2>
        </Title>
        <Box width={[1, 6 / 12]} mb="5rem">
          <SearchBar placeholder={t("searchWithKeywords")} />
        </Box>
      </Flex>
      <Flex shrink>
        <Box width={[1, 3 / 12]} mb={["2rem"]}>
          <SideBar path={path} groups={groups} />
        </Box>
        <Content color="gray" width={[1, 7 / 12]} pl={[0, "4rem"]}>
          {!isIndex &&
            frontmatter.items &&
            frontmatter.items.map((item, index) => {
              return (
                <div key={index}>
                  <h3
                    id={item.title ? slugify(item.title, { lower: true }) : ""}
                  >
                    {item.title}
                  </h3>
                  <NewHtmlComponent content={toHtml(item.description)} />
                </div>
              )
            })}
          {isIndex && <HelpCenterIndex></HelpCenterIndex>}
        </Content>
      </Flex>
    </>
  )
}

const HelpCenterPage = ({ data, path, isIndex }) => {
  let frontmatter
  if (!isIndex) {
    frontmatter = data.markdownRemark.frontmatter
    if (frontmatter.language) {
      setCurrentLang(frontmatter.language)
    }
  }
  return (
    <Layout secondary>
      <HelpCenterPageTemplate
        frontmatter={frontmatter}
        path={path}
        isIndex={isIndex}
      />
    </Layout>
  )
}

export const pageQuery = graphql`
  query HelpCenterPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        templateKey
        title
        language
        parent
        items {
          title
          description
          tags
        }
      }
    }
  }
`
export default HelpCenterPage
